import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserModelRequest } from '../_models/User/UserModel';
import { ApiService } from './api.service';

const API_URL = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private apiService: ApiService) { }

  getUserProfile(){
    return this.apiService.getUserProfile();
  }
  getAdminUserProfile(){
    return this.apiService.getAdminUserProfile();
  }
}
